// prevModelReducer.ts
import { ADD_PREV_MODEL, PrevModelAction } from '../actions/prevModelAction';

export interface PrevModule {
  ModuleID: number; // Use 'moduleID' instead of 'ModuleId'
  ModuleName: string;

  // Add other properties as needed
}

interface PrevModelState {
  prevModels: PrevModule[]; // Use 'Module' type directly here
}

const initialState: PrevModelState = {
  prevModels: [],
};

const prevModelReducer = (state = initialState, action: PrevModelAction): PrevModelState => {
  switch (action.type) {
    case ADD_PREV_MODEL:
      return {
        ...state,
        prevModels: [...state.prevModels, action.payload],
      };
    default:
      return state;
  }
};

export default prevModelReducer;
